module.exports = __webpack_public_path__ + "img/6da1569.jpg";